import React, { useState, useEffect } from "react";
import Userlist from "./UserList";
import AddNewUser from "./AddNewUser";
import { getUsers, deleteUser, AddUser } from "../../../API/Users";
import { toast } from "react-toastify";
import DeleteUser from "./DeleteUser";
import NoData from "../../../components/NoData";
import UserDetail from "./UserDetail";
import Pagination from "../../../utils/commonPagination";

const UserManagement = () => {
  const [addNewUser, setAddNewUser] = useState(false);
  const [DetailModal, setDetailModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState("");
  const [allUser, setAllUser] = useState([]);
  const [editUser, setEditUser] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const fatchUser = async (currentPage) => {
    try {
      const response = await getUsers(currentPage,itemsPerPage);
      if (response?.status) {
        setAllUser(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during login request:", error); // Handle any other errors
    }
  };

  useEffect(() => {
    if (!addNewUser) {
      fatchUser(currentPage);
    }
  }, [addNewUser,currentPage]);

  const handleAddNewUser = () => {
    setAddNewUser(!addNewUser);
    setEditUser({});
  };
  const handleUserDetail = (data) => {
    setEditUser(data);
    setDetailModal(true);
  };
  const handleEditUser = (data) => {
    setEditUser(data);
    setAddNewUser(true);
  };
  const handleDeleteUser = (id) => {
    setDeleteUserId(id);
  };
  const handleDeleteSubmit = async () => {
    try {
      const response = await deleteUser(deleteUserId);
      if (response?.status) {
        setDeleteUserId("");
        toast.success(response.message);
        fatchUser();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during login request:", error); // Handle any other errors
    }
  };

  const handleAccessChange = async (updatedUser) => {
    // Update the user state with the new access value
    setAllUser((prevUsers) =>
      prevUsers.users?.map((user) =>
        user.id === updatedUser.user_id
          ? { ...user, is_access: updatedUser.is_access }
          : user
      )
    );

    try {
      const response = await AddUser(updatedUser);
      if (response?.status) {
        toast.success(response.message || "success !");
        fatchUser();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during login request:", error); // Handle any other errors
    }
  };

  return (
    <div className="user_container">
      <div className="event_header management_header">
        <div className="title">User Management</div>
        <div className="event_button management_user">
          <button className="event_btn" onClick={() => handleAddNewUser()}>
            Create User
          </button>
        </div>
      </div>
      {allUser?.users && allUser?.users?.length > 0 ? (
        <div className="users_list table-responsive">
          <Userlist
            allUser={allUser?.users}
            onEditUser={handleEditUser}
            onDeleteUser={handleDeleteUser}
            onAccessChange={handleAccessChange}
            onUserDetail={handleUserDetail}
          />
           <Pagination
            currentPage={currentPage}
            totalNoPages={allUser?.totalNoPages}
            onNextPage={() => setCurrentPage(currentPage + 1)}
            onPreviousPage={() => setCurrentPage(currentPage - 1)}
          />
        </div>
      ) : (
        <NoData title="There is no user yet" />
      )}
      {addNewUser && (
        <AddNewUser onModalClose={handleAddNewUser} editUser={editUser} />
      )}
      {deleteUserId && (
        <DeleteUser
          onModalClose={setDeleteUserId}
          onSubmit={handleDeleteSubmit}
        />
      )}
      {DetailModal && (
        <UserDetail onUserModalClose={setDetailModal} UserData={editUser} />
      )}
    </div>
  );
};
export default UserManagement;
